import React, {useEffect, useRef, useState} from 'react';
//import { login } from '../../services/authService';

import { useLocation, useNavigate } from "react-router";
import {useSearchParams} from "react-router-dom";

import FooterCabana from "./FooterCabana";

import { Autocomplete as GoogleAutocomplete  } from "@react-google-maps/api";

import {
    FormControl,
    InputLabel,
    Input,
    FormHelperText,
    Button,
    TextField,
    Modal,
    Typography,
    Alert,
    AlertTitle,
    Collapse,
    IconButton,
    InputAdornment, Checkbox, Select, MenuItem, BaseTextFieldProps, FormControlLabel, Divider, Autocomplete
} from '@mui/material';
import Header from '../Header';
import './PublicRegistration.css';
import { useTranslation, withTranslation, WithTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import {Visibility} from "@mui/icons-material";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Link} from "react-router-dom";
import {validateEmail, validatePassword} from "../../services/CheckUtils";
import dataProvider from "../../provider/api-interface";
import {changeLanguage} from "i18next";

import Background from "../../media/images/LoginBackground.jpg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {defaultCountries, FlagEmoji, parseCountry, usePhoneInput} from "react-international-phone";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {isValidPhoneNumber} from "react-phone-number-input";
import jwt from "jwt-decode";
import {frontendBaseURL, mainRolesRoutes, rolesCodes} from "../../global";

import 'react-international-phone/style.css';
import {setFilterSortProducts} from "../search-engine/Utils";
import {useCabanaContext} from "../CabanaContext";
import {isWishlistSoftDeleted} from "../../utils/wishlistStatus";

export interface MUIPhoneProps extends BaseTextFieldProps {
    value: string;
    onChange: (phone: string) => void;
    defaultCountryString: string;
}

const MuiPhone: React.FC<MUIPhoneProps> = ({
                                               value,
                                               onChange,
                                               defaultCountryString,
                                               ...restProps
                                           }) => {
    const { t, i18n } = useTranslation();
    const { phone, handlePhoneValueChange, inputRef, country, setCountry } =
        usePhoneInput({
            defaultCountry: defaultCountryString,
            value,
            countries: defaultCountries,
            onChange: (data) => {
                setReadOnly(true);
                onChange(data.phone);
                //console.log(data);
                setReadOnly(false)
            },
        });
    const [readOnly, setReadOnly] = useState<any>(true);

    return (
        <TextField
            variant="outlined"
            label={t("phoneLabel")}
            color="primary"
            placeholder="Phone number"
            value={phone}
            onChange={handlePhoneValueChange}
            type="tel"
            inputRef={inputRef}
            InputProps={{
                readOnly: readOnly,
                startAdornment: (
                    <InputAdornment
                        position="start"
                        style={{ marginRight: '2px', marginLeft: '-8px' }}
                    >
                        <Select
                            MenuProps={{
                                style: {
                                    height: '300px',
                                    width: '360px',
                                    top: '10px',
                                    left: '-34px',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                            }}
                            sx={{
                                width: 'max-content',
                                // Remove default outline (display only on focus)
                                fieldset: {
                                    display: 'none',
                                },
                                '&.Mui-focused:has(div[aria-expanded="false"])': {
                                    fieldset: {
                                        display: 'block',
                                    },
                                },
                                // Update default spacing
                                '.MuiSelect-select': {
                                    padding: '8px',
                                    paddingRight: '24px !important',
                                },
                                svg: {
                                    right: 0,
                                },
                            }}
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            renderValue={(value) => (
                                <FlagEmoji iso2={value} style={{ display: 'flex' }} />
                            )}
                        >
                            {defaultCountries.map((c) => {
                                const country = parseCountry(c);
                                return (
                                    <MenuItem key={country.iso2} value={country.iso2}>
                                        <FlagEmoji
                                            iso2={country.iso2}
                                            style={{ marginRight: '8px' }}
                                        />
                                        <Typography marginRight="8px">{country.name}</Typography>
                                        <Typography color="gray">+{country.dialCode}</Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </InputAdornment>
                ),
            }}
            {...restProps}
        />
    );
};
function EditWishlist() {
    const {forceRefreshWishlist} = useCabanaContext();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const date = new Date();

    const [defaultCountry, setDefaultCountry] = useState<any>('en_gb');
    const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);


    /*const [role, setRole] = useState<string>(props.role);
    const [routeRedirect, setRouteRedirect] = useState<string>(props.routeRedirect);*/
    /*const [name, setName] = useState<string>("");
    const [surname, setSurname] = useState<string>("");*/
    const [phone, setPhone] = useState<any>("");

    /*const [eventName, setEventName] = useState<string>("");
    const [eventDate, setEventDate] = useState<number>(date.setDate(date.getDate() + 30));
    const [closingDate, setClosingDate] = useState<number>(date.setDate(date.getDate() + 180));*/

    const [shippingCountry, setShippingCountry] = useState<string>("");
    const [shippingCity, setShippingCity] = useState<string>("");
    const [shippingState, setShippingState] = useState<string>("");
    const [shippingAddressLine1, setShippingAddressLine1] = useState<string>("");
    const [shippingAddressLine2, setShippingAddressLine2] = useState<string>("");
    const [shippingZipCode, setShippingZipCode] = useState<string>("");
    const [choicedPickup, setChoicedPickup] = useState<boolean>(false);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<"error" | "success" | "warning">("error");
    const [alertText, setAlertText] = useState<any>(t('wrongCredentials'));

    const wishlistCode = window.location.pathname.split('/')[3];
    const [wishlist, setWishlist] = useState<any>(null);
    const [wishlistUrl, setWishlistUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const location = useLocation();

    const [jwtToken, setJwtToken] = useState<string | null>(null);
    const [user, setUser] = useState<any>(null);

    const autocompleteRef: any = useRef(null);

    const handlePlaceChanged = () => {
        const place = autocompleteRef?.current?.getPlace();

        if (!place || !place.address_components) return;

        const addressComponents = place.address_components;

        const getComponent = (type: any) =>
            type !== 'administrative_area_level_2' && type !== 'country' ? addressComponents.find((component: any) =>
                component.types.includes(type)
            )?.long_name || "" : addressComponents.find((component: any) =>
                component.types.includes(type)
            )?.short_name || "";

        const selectedCountry = getComponent("country");
        const countryObj: any = defaultCountries.find((country: any) => country[1] === selectedCountry.toLowerCase());

        setShippingAddressLine1(
            getComponent("street_number") !== '' ?
            getComponent("route")+', '+getComponent("street_number") :
            getComponent("route")
        ); // Via e numero civico se presente
        setShippingCity(getComponent("locality")); // Città
        setShippingState(getComponent("administrative_area_level_2")); // Provincia
        setShippingZipCode(getComponent("postal_code")); // CAP
        setShippingCountry(countryObj[0]); // Nazione
    };

    if(wishlistCode === undefined || wishlistCode === null || wishlistCode === '') {
        setAlertText('Invalid wishlist code');
        setAlertOpen(true);
        setTimeout(() => {
            navigate('/');
        }, 2000);
    }

    React.useEffect(() => {
        async function fetchWishlist() {
            //let filters = '';
            //}
            let token: any = jwtToken === null ? localStorage.getItem('token') : sessionStorage.getItem('token');
            if(token !== null) {
                setJwtToken(token);
                let user: any = jwt(token);
                if(user.role !== 1) {
                    navigate('/login');
                }
                setUser(user);
                let data = await dataProvider.getWishlistByListCode(wishlistCode, token).then((data: any) => {
                    if (data === null) {
                        //navigate(`/${pathName}/404`);
                        setIsLoading(false)
                        return;
                    }
                    if (isWishlistSoftDeleted(data)) {
                        navigate('/giftee/list-unavailable-message');
                        return;
                    }
                    setWishlist(data);
                    if(data.giftee.phone_number !== null) {
                        setPhone(data.giftee.phone_number);
                    }

                    if(data.delivery_country_or_region !== null) {
                        setShippingCountry(data.delivery_country_or_region);
                    }

                    if(data.delivery_city !== null) {
                        setShippingCity(data.delivery_city);
                    }

                    if(data.delivery_state !== null) {
                        setShippingState(data.delivery_state);
                    }

                    if(data.delivery_address_line_1 !== null) {
                        setShippingAddressLine1(data.delivery_address_line_1);
                    }

                    if(data.delivery_address_line_2 !== null) {
                        setShippingAddressLine2(data.delivery_address_line_2);
                    }

                    if(data.delivery_zip_code !== null) {
                        setShippingZipCode(data.delivery_zip_code);
                    }

                    if(data.choiced_pickup_option !== null) {
                        setChoicedPickup(data.choiced_pickup_option === 1 ? true : false);
                    }

                    setIsLoading(false);
                    setWishlistUrl(frontendBaseURL + '/' + mainRolesRoutes.gifter + '/registry/' + data.list_code);
                });
            }

            //setWishlistItems(data.items);
        }

        fetchWishlist();
    },[wishlistCode]);


    const setLanguage = (language: string) => {
        i18n.changeLanguage(language);
    }
    const validatePhoneNumber = (phone: string) => {
        //console.log('+'+phone)
        //console.log(isValidPhoneNumber('+'+phone))
        return isValidPhoneNumber(phone);
    }

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        setButtonDisabled(true);
        //PERSONAL INFO
        /*if(name === "") {
            setAlertText(t('emptyName'));
            setAlertOpen(true);
            setButtonDisabled(false);
            autoClose();
            return;
        }

        if(surname === "") {
            setAlertText(t('emptySurname'));
            setAlertOpen(true);
            setButtonDisabled(false);
            autoClose();
            return;
        }*/

        if(phone === "") {
            setAlertText(t('emptyPhone'));
            setAlertType("warning");
            setAlertOpen(true);
            setButtonDisabled(false);
            autoClose();
            return;
        }

        //VALIDATE MAIL AND PHONE
        if (!validatePhoneNumber(phone)) {
            //console.log(phone);
            setAlertText(t('phoneNotValid'));
            setAlertType("error");
            setAlertOpen(true);
            setButtonDisabled(false);
            autoClose();
            return;
        }

        //GIFT LIST INFO
        /*if(eventName === "") {
            setAlertText(t('emptyEventName'));
            setAlertType("warning");
            setAlertOpen(true);
            autoClose();
            setButtonDisabled(false);
            return;
        }

        if(!checkDates(eventDate, closingDate)) {
            setAlertText(t('closingDateError'));
            setAlertType("warning");
            setAlertOpen(true);
            autoClose();
            setButtonDisabled(false);
            return;
        }*/

        //let formattedEventDate = dayjs(eventDate).format('YYYY-MM-DDTHH:mm:ss.sssZ');
        //let formattedClosingDate = dayjs(closingDate).format('YYYY-MM-DDTHH:mm:ss.sssZ');

        let updateObject: any = {
            phone_number: phone,
            choiced_pickup_option: choicedPickup === true ? 1 : 0
        };

        if(!choicedPickup) {
            if (shippingCountry === "") {
                setAlertText(t('emptyShippingCountry'));
                setAlertType("warning");
                setAlertOpen(true);
                autoClose();
                setButtonDisabled(false);
                return;
            }

            if (shippingCity === "") {
                setAlertText(t('emptyShippingCity'));
                setAlertType("warning");
                setAlertOpen(true);
                autoClose();
                setButtonDisabled(false);
                return;
            }

            if (shippingState === "") {
                setAlertText(t('emptyShippingState'));
                setAlertType("warning");
                setAlertOpen(true);
                autoClose();
                setButtonDisabled(false);
                return;
            }

            if (shippingAddressLine1 === "") {
                setAlertText(t('emptyShippingAddressLine1'));
                setAlertType("warning");
                setAlertOpen(true);
                autoClose();
                setButtonDisabled(false);
                return;
            }

            if (shippingZipCode === "") {
                setAlertText(t('emptyShippingZipCode'));
                setAlertType("warning");
                setAlertOpen(true);
                autoClose();
                setButtonDisabled(false);
                return;
            }

            updateObject = {
                //name: name,
                //surname: surname,
                phone_number: phone,
                //giftlist_name: eventName,
                //event_date: formattedEventDate,
                //end_date: formattedClosingDate
                delivery_country_or_region: shippingCountry,
                delivery_city: shippingCity,
                delivery_state: shippingState,
                delivery_address_line_1: shippingAddressLine1,
                delivery_address_line_2: shippingAddressLine2,
                delivery_zip_code: shippingZipCode
            }
        }

        const objectForUpdate = {
            wishlistParams: updateObject
        }

        await dataProvider.update( 'wishlist', wishlist.id ,objectForUpdate, jwtToken).then((response: any) => {
            if(response !== null) {
                setAlertText('Shipping data updated successfully');
                setAlertOpen(true);
                setAlertType("success");
                setTimeout(() => {
                    forceRefreshWishlist();
                    navigate(`/giftee/registry/${wishlist.list_code}`);
                }, 1500);
            } else {
                setAlertText('Error updating shipping data, please try again.');
                setAlertOpen(true);
                setAlertType("error");
                setButtonDisabled(false);
                autoClose();
            }
        });

    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const autoClose = () => {
        setTimeout(() => {
            setAlertOpen(false);
        }, 3000);
    };

    const checkDates = (eventDate: any, closingDate: any): boolean => {
        let eventDateNumber = parseInt(eventDate);
        let closingDateNumber = parseInt(closingDate);
        if(eventDateNumber === 0 || closingDateNumber === 0) {
            return false;
        }

        if(eventDateNumber > closingDateNumber) {
            return false;
        }

        return true;
    }


    let countriesForSelect: any = [];
    defaultCountries.map((country: any) => {
        countriesForSelect.push(country[0]);
    });

    return (
        <div>
            <Header hideLanguageSelect={true} link={`/giftee/registry/${wishlist?.list_code}`} textLink={t('backTo')} />
            <div className="row no-gutter">
                <div className="col-12 col-lg-6 PublicRegistrationTitle" style={{
                    minHeight: '21vh',
                    height: 'calc(100vh - 60px)',
                    background: `url(${Background})`,
                    backgroundSize: 'cover',
                    backgroundPosition: '50% 48%',
                    backgroundRepeat: 'no-repeat'
                }}>
                    <h3 style={{fontSize: '24px', fontWeight: '400'}} className="d-block d-lg-none text-uppercase">Wedding List</h3>
                </div>
                <div className="col-12 col-lg-6 d-lg-flex align-items-lg-center">
                    <Collapse className="FgiftCustomCollapse" in={alertOpen}>
                        <Alert severity={alertType}
                               onClose={() => setAlertOpen(false)}
                               action={
                                   <IconButton
                                       aria-label="close"
                                       color="inherit"
                                       size="small"
                                       onClick={() => {
                                           setAlertOpen(false);
                                       }}
                                   >
                                       <CloseIcon fontSize="inherit"/>
                                   </IconButton>
                               }
                        >
                            {alertText}
                        </Alert>
                    </Collapse>
                    <div className="row w-100">
                        <div className="col-12 col-lg-4 d-none d-lg-block">
                            <h5 className="d-none d-lg-block text-uppercase px-3 mt-3 mb-3"
                                style={{fontWeight: '400', fontSize: '18px'}}>Delivery<br/>Information</h5>
                        </div>
                        <div className="col-12 col-lg-8">
                            <form className="LoginForm PublicRegistrationForm" onSubmit={handleFormSubmit}>
                                {/*<div style={{marginBottom: '30px'}} className="FormContainer">
                                    <div className="FormTitle"><h4>{t("publicRegister.personalInformation")}</h4></div>
                                    <TextField
                                        label={t("nameLabel")}
                                        value={name}
                                        onChange={(event) => {
                                            setName(event.target.value);
                                        }}
                                        required={true}
                                        variant="outlined"
                                    />
                                    <TextField
                                        label={t("surnameLabel")}
                                        value={surname}
                                        onChange={(event) => {
                                            setSurname(event.target.value);
                                        }
                                        }
                                        required={true}
                                        variant="outlined"
                                    />
                                </div>
                                <div className="FormContainer mt-5 mt-lg-0">
                                    <div className="FormTitle"><h4>{t("publicRegister.giftListDetails")}</h4></div>
                                    <TextField
                                        label={t('publicRegister.giftListName')}
                                        value={eventName}
                                        onChange={(event) => {
                                            setEventName(event.target.value);
                                        }}
                                        required={true}
                                        variant="outlined"
                                    />
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={t('eventDateLabel')}
                                            value={dayjs(eventDate)}
                                            onChange={(newValue) => {
                                                let datesToCheck = (newValue === null) ? 0 : dayjs(newValue).valueOf();
                                                setEventDate(datesToCheck)
                                                if (!checkDates(datesToCheck, closingDate)) {
                                                    setAlertOpen(true);
                                                    setAlertText(t('closingDateError'))
                                                    setAlertType("warning");
                                                    autoClose();
                                                }
                                            }}
                                            format={'DD/MM/YYYY'}
                                            slotProps={{
                                                textField: {
                                                    variant: 'outlined',
                                                    helperText: t('loginSignupPage.startDateHelper')
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={t('closingDateLabel')}
                                            value={dayjs(closingDate)}
                                            onChange={(newValue) => {
                                                let datesToCheck = (newValue === null) ? 0 : dayjs(newValue).valueOf();
                                                setClosingDate(datesToCheck)
                                                if (!checkDates(eventDate, datesToCheck)) {
                                                    setAlertOpen(true);
                                                    setAlertText(t('closingDateError'))
                                                    setAlertType("warning")
                                                    autoClose();
                                                }
                                            }}
                                            format={'DD/MM/YYYY'}
                                            slotProps={{
                                                textField: {
                                                    variant: 'outlined',
                                                    helperText: t('loginSignupPage.endDateHelper')
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>*/}
                                <div className="FormContainer mt-2 mt-lg-4">
                                    <div className="FormTitle d-block d-lg-none">
                                        <h4 style={{fontWeight: '400', fontSize: '18px'}}>Delivery Information</h4>
                                    </div>
                                    <Autocomplete
                                        options={countriesForSelect} // Usa l'array di opzioni
                                        getOptionLabel={(option) => option} // Trasforma l'opzione in stringa (se è un oggetto personalizza qui)
                                        value={shippingCountry} // Mantieni il valore selezionato
                                        onChange={(event, newValue) => {
                                            setShippingCountry(newValue); // Aggiorna lo stato con il valore selezionato
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={t('publicRegister.shippingCountry')}
                                                variant="outlined"
                                                //required={!choicedPickup}
                                                disabled={choicedPickup}
                                            />
                                        )}
                                        disabled={choicedPickup || shippingCountry !== ""} // Disabilita se choicedPickup è true o se shippingCountry è già selezionato
                                        disableClearable // Se non vuoi permettere la cancellazione
                                    />
                                    <GoogleAutocomplete
                                        onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                                        onPlaceChanged={handlePlaceChanged}
                                    >
                                        <TextField
                                            label="Street Address *"
                                            variant="outlined"
                                            fullWidth
                                            disabled={choicedPickup}
                                            value={shippingAddressLine1}
                                            onChange={(e) => setShippingAddressLine1(e.target.value)}
                                        />
                                    </GoogleAutocomplete>
                                    <TextField
                                        label={t('publicRegister.shippingCity')}
                                        value={shippingCity}
                                        onChange={(event) => {
                                            setShippingCity(event.target.value);
                                        }}
                                        disabled={choicedPickup}
                                        //required={!choicedPickup}
                                        variant="outlined"
                                    />
                                    <TextField
                                        label="State/Province *"
                                        value={shippingState}
                                        onChange={(event) => {
                                            setShippingState(event.target.value);
                                        }}
                                        disabled={choicedPickup}
                                        //required={!choicedPickup}
                                        variant="outlined"
                                    />
                                    {/*<TextField
                                        label={t('publicRegister.shippingAddressLine2')}
                                        value={shippingAddressLine2}
                                        onChange={(event) => {
                                            setShippingAddressLine2(event.target.value);
                                        }}
                                        disabled={choicedPickup}
                                        variant="outlined"
                                    />*/}
                                    <TextField
                                        label={t('publicRegister.shippingZipCode')}
                                        value={shippingZipCode}
                                        onChange={(event) => {
                                            setShippingZipCode(event.target.value);
                                        }}
                                        disabled={choicedPickup}
                                        //required={!choicedPickup}
                                        variant="outlined"
                                    />
                                    <MuiPhone value={phone} onChange={(event) => {
                                        setPhone(event);
                                        //console.log(event, 'phone');
                                    }}
                                              defaultCountryString={'it'}
                                    ></MuiPhone>
                                    <Divider sx={{borderColor: "#cccccc",width: "105%", marginTop: '40px', marginBottom: '30px'}} component="div" />
                                    <FormControlLabel
                                        className="d-flex align-items-start"
                                        control={
                                        <Checkbox
                                            color="primary"
                                            required={false}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            checked={choicedPickup}
                                            onChange={(event) => {
                                                setChoicedPickup(event.target.checked);
                                            }}
                                        />
                                    }
                                        label={
                                            <div style={{marginTop: '6px', marginBottom: '10px'}}><span className="PickupLabel d-block">Store Pickup Available</span><span className="PickupSubLabel" >Easily collect your order directly from a
                                                nearby store location.</span>
                                            </div>
                                        }/>
                                </div>
                                <div className="ButtonContainer EditButtonContainer" style={{position: 'relative', maxWidth: '100% !important', width: '100% !important'}}>
                                    <button style={{ maxWidth: '100% !important', width: '100% !important'}} disabled={buttonDisabled} id="signup-confirm-button" type="submit"
                                            className="Fgift-button">
                                        {t('publicRegister.submit')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withTranslation()(EditWishlist);
